export class AnimatedPipe {
  static arrowTexture: any;

  obj3D: any;

  context: any;

  arrowMaterial: any;

  inputs = {
    opacityDefault: 0,
    textureRotation: Math.PI / 2,
    textureRepeat: { x: 1, y: 4 },
    textureOffset: { x: 0, y: 0 },
  };

  constructor(obj3D, inputs: any, context) {
    this.obj3D = obj3D.clone();
    obj3D.parent.add(this.obj3D);
    this.inputs = { ...this.inputs, ...inputs };
    this.context = context;
    this.arrowMaterial = this.initAnimatedMaterial();
    this.obj3D.material = this.arrowMaterial;
  }

  static async preloadTextures(loader) {
    this.arrowTexture = await loader.load('/images/Arrow-Right.png');
  }

  initAnimatedMaterial() {
    const THREE = this.context.three;
    const arrowTexture = AnimatedPipe.arrowTexture.clone();
    arrowTexture.rotation = this.inputs.textureRotation;
    arrowTexture.wrapS = THREE.RepeatWrapping;
    arrowTexture.wrapT = THREE.RepeatWrapping;
    arrowTexture.repeat.set(this.inputs.textureRepeat.x, this.inputs.textureRepeat.y);
    arrowTexture.offset.set(this.inputs.textureOffset.x, this.inputs.textureOffset.y);

    arrowTexture.needsUpdate = true;

    return new THREE.MeshBasicMaterial({
      map: arrowTexture,
      transparent: true,
      opacity: this.inputs.opacityDefault,
      depthTest: false,
      depthWrite: false,
      side: THREE.FrontSide,
    });
  }
}
